import { defaultState } from '../event-centre-dialog.state';
import { FilterOptions } from '../model/filter-options.model';

export function filterIsDefault(opts: FilterOptions): {
    search: boolean;
    filter: boolean;
} {
    const ds = defaultState().filterOpts;
    return {
        search: (opts.keyword ?? '') === (ds.keyword ?? ''),
        filter:
            ((opts.statuses == null && ds.statuses == null) ||
                (opts.statuses.length === ds.statuses.length &&
                    opts.statuses.every((e) => ds.statuses.includes(e)) &&
                    ds.statuses.every((e) => opts.statuses.includes(e)))) &&
            opts.dateRange?.from?.getTime() === +ds.dateRange.from &&
            opts.dateRange?.to?.getTime() === +ds.dateRange.to &&
            opts.itemIds === ds.itemIds,
    };
}
